import { Modal } from "antd";
import { observer } from "mobx-react";
import { __ } from "../../../../utils";
import { ChangePaymentDetailsForm } from ".";
const ChangePaymentDetailsModal = observer(_ref => {
  let {
    record,
    visible,
    onClose
  } = _ref;
  if (!record.data.ecommerceSystemSubscriptionId) {
    // Payment method can only be changed, if subscriptions is referenced in a ecommerce system
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    open: visible,
    title: __("Change payment details"),
    cancelText: __("Cancel"),
    onCancel: onClose,
    okButtonProps: {
      style: {
        display: "none"
      }
    },
    style: {
      minWidth: 700
    },
    destroyOnClose: true
  }, /*#__PURE__*/React.createElement(ChangePaymentDetailsForm, {
    record: record
  }));
});
export { ChangePaymentDetailsModal };